// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1twK-","load6":"Spinner_load6__1_74m","round":"Spinner_round__3G_CY"};